let audioCtx;

// Synthesized two-tone "ding" so all three panels (admin/expert/user) play
// the exact same sound without bundling/loading an audio file per app.
export const playNotificationSound = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;

    audioCtx = audioCtx || new Ctx();
    if (audioCtx.state === "suspended") audioCtx.resume();

    const now = audioCtx.currentTime;
    const gain = audioCtx.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.2, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.3);
    gain.connect(audioCtx.destination);

    [880, 1320].forEach((freq, i) => {
      const osc = audioCtx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.connect(gain);
      const start = now + i * 0.1;
      osc.start(start);
      osc.stop(start + 0.15);
    });
  } catch (err) {
    console.error("Notification sound failed:", err);
  }
};
